module.exports = __webpack_public_path__ + "static/media/pocker.23ae3c55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pocker.svg
// module id = 392
// module chunks = 7